

























import _ from 'lodash';
import { locale } from '@/i18n';
import { Component, Vue, Model, Prop, Watch } from 'vue-property-decorator';
import { mapActions, mapGetters } from 'vuex';

@Component
export default class OrdersDatePicker extends Vue {
  locale: string|undefined = locale;
  localState: Object = {};
  @Prop() label: any;
  @Prop() icon: string;
  @Model('change', { default: Object }) modelState: Object;
  @Watch('localState') watchLocalState(localState: Object, localStateOld: Object) {
    if (!_.isEqual(localState, localStateOld)) {
      this.$emit('change', localState);
    }
  }
  @Watch('modelState') watchModelState(modelState: Object, modelStateOld: Object) {
    if (!_.isEqual(modelState, modelStateOld)) {
      this.localState = _.cloneDeep(modelState);
    }
  }

  mounted() {
    this.localState = _.cloneDeep(this.modelState);
  }
}
